<template>
<div class="is-fullheight is-flex align-center justify-center">
  <div class="auth-box">
    <div class="has-text-centered">
      <logo width="10rem" />
    </div>
    <form class="box">
      <div class="has-text-centered">
        <h3 class="title is-4">Forgot Password</h3>
      </div>

      <div class="columns">
        <div class="column">
          <text-input :error="$root.errors.email" v-model="reset.email">Email</text-input>
        </div>
      </div>

      <div class="columns">
        <div class="column has-text-centered">
          <submit-button class="is-rounded" :working="working" @submit="performReset">Submit</submit-button>
        </div>
      </div>
    </form>
  </div>
</div>    
</template>
<script>
import { post } from '@/api/request'

export default {
  
  data: () => ({
    loading: false,
    working: false,
    reset: {
      email: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Forgot Password')
  },

  methods: {
    performReset() {
      post('/api/forgot-password', this.reset, ({data}) => {
        this.$alert({
          title: 'Forgot Password',
          message: 'If your account exists you will receive an email with instructions to reset your password.'
        })
        this.$router.push('/')
      }, error => {})
    }
  }

}
</script>